export { default } from "./Facets";
export { type IFacetsProps, type IActiveFacet } from "./types";
